module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-upload', {
    ref: "excelUploader",
    staticClass: "upload-demo",
    attrs: {
      "accept": ".xlsx, .xls",
      "action": _vm.uploadApi,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "before-remove": _vm.beforeRemove,
      "on-exceed": _vm.handleExceed,
      "file-list": _vm.fileList,
      "limit": 1,
      "data": _vm.upLoadParams,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "headers": _vm.headers
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2556b76d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2556b76d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadExcel/UploadExcel.vue
// module id = 1268
// module chunks = 1